'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _keyToObjectValueResolver = require('./keyToObjectValueResolver');

var _keyToObjectValueResolver2 = _interopRequireDefault(_keyToObjectValueResolver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var keysToValuesResolver = function keysToValuesResolver(name, keys) {
  return function (data, breakpointName) {
    return (0, _ramda.map)(function (key) {
      return (0, _keyToObjectValueResolver2.default)(name)(key, data, breakpointName);
    }, keys);
  };
};

exports.default = keysToValuesResolver;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/resolvers/keysToObjectValuesResolver.js
// module id = 661
// module chunks = 168707334958949